var link_preview_default = {
  "fontElementMap": "tlgf6",
  "linkPreviewContainer": "TwnPk",
  "linkPreview": "SZSvS",
  "linkPreviewImage": "_8e30X",
  "linkPreviewPlaceholder": "WFFtA",
  "linkPreviewInfo": "UqI0L",
  "linkPreviewTitle": "tL6L0",
  "linkPreviewDescription": "y-2lJ",
  "linkPreviewUrl": "VskoE",
  "linkPreviewResponsiveImage": "kBc8K",
  "loadingContainer": "ZjWiA",
  "errorIcon": "f9xxN",
  "errorInfo": "RG-Ir",
  "errorContainer": "Uutui",
  "overlay": "cmXzw",
  "thumbnailEnd": "jvX9O",
  "thumbnailStart": "kkZcw",
  "thumbnailTop": "xk9RC"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
